import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DistrictOfficialData } from 'src/app/models/DistrictData';

@Component({
  selector: 'app-district-level-official',
  templateUrl: './district-level-official.component.html',
  styleUrls: ['./district-level-official.component.scss']
})
export class DistrictLevelOfficialComponent  {
  districtOfficials: DistrictOfficialData[] =[];
  constructor(
    private dialogRef: MatDialogRef<DistrictLevelOfficialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DistrictOfficialData[],
    private matDialog: MatDialog){
      this.districtOfficials = data;
      
  }

  closeDialog(){
    this.dialogRef.close();
  }
}
